"use client";

import { Check } from "lucide-react";
import { cn } from "@ocr-monorepo/ui/lib/utils";

interface Step {
  id: string;
  title: string;
}

interface StepIndicatorProps {
  activeIndex: number;
  steps: Step[];
}

export function StepIndicator({ activeIndex, steps }: StepIndicatorProps) {
  return (
    <nav aria-label="Onboarding progress">
      <ol className="flex items-center justify-center gap-4">
        {steps.map((step, index) => {
          const isCompleted = index < activeIndex;
          const isActive = index === activeIndex;

          return (
            <li key={step.id} className="flex items-center gap-4">
              {index > 0 && (
                <span className="h-px w-6 bg-border" aria-hidden="true" />
              )}
              <div
                className="flex items-center gap-2 whitespace-nowrap"
                aria-current={isActive ? "step" : undefined}
              >
                <span
                  className={cn(
                    "flex size-[26px] shrink-0 items-center justify-center rounded-full border text-[13px] font-semibold",
                    isActive || isCompleted
                      ? "border-primary bg-primary text-primary-foreground"
                      : "border-border text-muted-foreground",
                  )}
                >
                  {isCompleted ? (
                    <Check className="size-3.5" aria-hidden="true" />
                  ) : (
                    index + 1
                  )}
                </span>
                <span
                  className={cn(
                    "text-sm",
                    isActive
                      ? "font-semibold text-foreground"
                      : "text-muted-foreground",
                  )}
                >
                  {step.title}
                </span>
              </div>
            </li>
          );
        })}
      </ol>
    </nav>
  );
}
